export default __webpack_public_path__ + "static/Read legal docs faster-40b0e469307ad06bfa5b33caa654e659.png";